export default "__VITE_ASSET__BNxu2Y41__"